export const DEFAULT_PRINT_OPTIONS = {
  orientation: "landscape",
  showClassroom: true,
  showStudentCount: true,
  showConflictsWarnings: true,
  printOnePerPage: false,
};
